
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Device"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imei"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mobile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"containerContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"driverName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"driverMobile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"humidity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"temperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batteryVoltage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recordedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"setting"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminMobile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mobilesForNotices"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alarm"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deviceTemperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxTemperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minTemperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxHumidity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minHumidity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deviceHumidity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deviceBattery"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batteryAlarmLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"samplingTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lightSensor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lightPercent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gpsTimeout"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deviceTimeout"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mobile"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":676}};
    doc.loc.source = {"body":"fragment ItemFull on Device {\n  id\n  imei\n  mobile\n  title\n  description\n  containerContent\n  containerNumber\n  driverName\n  driverMobile\n  lastReport {\n    humidity\n    temperature\n    address\n    batteryVoltage\n    recordedAt\n    createdAt\n  }\n  setting {\n    adminMobile\n    mobilesForNotices\n    alarm {\n      title\n      deviceTemperature\n      maxTemperature\n      minTemperature\n      maxHumidity\n      minHumidity\n      deviceHumidity\n      deviceBattery\n      batteryAlarmLevel\n      samplingTime\n      lightSensor\n      lightPercent\n      gpsTimeout\n      deviceTimeout\n    }\n  }\n  user {\n    id\n    name\n    role\n    gender\n    mobile\n  }\n  createdAt\n  updatedAt\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ItemFull"] = oneQuery(doc, "ItemFull");
        
